<a class="back-to-app" gp-test-id="handbookbacktoappextension-button" (click)="backToApp()">{{ "HANDBOOK.BACK_TO_APP" | translate }}</a>
